<template>
  <div>
    <v-card color="grey lighten-4 my-3">
      <v-toolbar dense>
        <v-toolbar-title>Transaksi Berhasil</v-toolbar-title>

        <v-spacer></v-spacer>
        <div class="pa-5">
          <!-- <v-text-field
            flat
            dense
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search"
            class="hidden-sm-and-down"
          />-->
        </div>
      </v-toolbar>
    </v-card>
    <v-simple-table fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">No. Invoice</th>
            <th class="text-left">Alamat Pengiriman</th>
            <th class="text-left">Total Bayar</th>
            <th class="text-left">Tanggal Bayar</th>
            <th class="text-left">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in dataFinish" :key="item.name">
            <td>{{ item.No_Invoice }}</td>
            <td>{{ item.Alamat }}</td>
            <td>{{item.Nominal | currency}}</td>
            <td>{{item.Bayar}}</td>
            <td>{{item.Status}}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-card color="grey lighten-4 my-3">
      <v-toolbar dense>
        <v-toolbar-title>Proses Kirim</v-toolbar-title>

        <v-spacer></v-spacer>
        <div class="pa-5">
          <!-- <v-text-field
            flat
            dense
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search"
            class="hidden-sm-and-down"
          />-->
        </div>
      </v-toolbar>
    </v-card>
    <v-simple-table fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">No. Invoice</th>
            <th class="text-left">No. Resi</th>
            <th class="text-left">Alamat Pengiriman</th>
            <th class="text-left">Total Bayar</th>
            <th class="text-left">Tanggal Bayar</th>
            <th class="text-left"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in dataKirim" :key="item.name">
            <td>{{ item.No_Invoice }}</td>
            <td>{{ item.No_Resi }}</td>
            <td>
              <div>{{ item.Alamat }}</div>
            </td>
            <td>{{item.Nominal | currency}}</td>
            <td>{{item.Bayar}}</td>
            <td>
              <v-btn @click="Selesai(item)" outlined small>Selesaikan</v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      userid: localStorage.getItem("user_id"),
      dataKirim: [],
      dataFinish: []
    };
  },
  mounted() {
    this.getPesanan();
    this.getSelesai();
  },
  methods: {
    getPesanan() {
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/penerima/" +
          this.userid +
          "/kirim"
      )
        .then(response => response.json())
        .then(data => {
          this.dataKirim = data;
        });
    },
    getSelesai() {
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/penerima/" +
          this.userid +
          "/selesai"
      )
        .then(response => response.json())
        .then(data => {
          this.dataFinish = data;
        });
    },
    Selesai(data) {
      Swal.fire({
        title: "Konfirmasi",
        text: "Apakah barang sudah diterima dan sesuai ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Selesaikan"
      }).then(result => {
        if (result.value) {
          this.overlay = true;
          fetch(
            "http://meridinet.saebo.id:2082/Login/api/ProsesKirim?waybill=&order=" +
              data +
              "&kirim=jne"
          )
            .then(response => response.json())
            .then(data => {
              if (data.status.code != 404) {
                this.overlay = false;
                Swal.fire("Selesai!", "Transaksi di selesaikan!", "success");
                window.location.reload();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Terjadi Kesalahan!"
                });
              }
            });
        }
      });
    }
  }
};
</script>